<div class="offcanvas-header border-bottom">
  <div>
    <h5 class="offcanvas-title premium-heading mb-1">
      @if (mode === 'ADD') {
        Add Expense
      }
      @if (mode === 'VIEW') {
        Expense Detail
      }
      @if (mode === 'EDIT') {
        Edit Expense
      }
    </h5>
    @if (mode !== 'ADD') {
      <div class="premium-subtitle">
        {{ expenseData?.expId || 'New' }}
        @if (expenseData?.description) {
          <span>&middot; {{ expenseData?.description }}</span>
        }
      </div>
    }
  </div>
  <button type="button" class="btn-close text-reset shadow-none" aria-label="Close"
  [disabled]="saveLoader || deleteLoader" (click)="activeOffcanvas.dismiss('Cross click')"></button>
</div>
<div #offcanvasBody class="offcanvas-body p-4 bg-light custom-scrollbar">
  <!-- Error Alert -->
  @if (formErrorMessage) {
    <div
      class="alert alert-danger py-2 mb-3 small d-flex justify-content-between align-items-center rounded-3">
      <span>{{ formErrorMessage }}</span>
      <button type="button" class="btn-close small py-1 shadow-none" style="font-size: 0.75rem;"
      (click)="formErrorMessage = ''"></button>
    </div>
  }
  <!-- VIEW MODE -->
  @if (mode === 'VIEW') {
    <!-- Main Values Card -->
    <div class="premium-view-card mb-4 text-center">
      <div class="mb-2">
        <span class="badge rounded-pill px-3 py-1" [ngStyle]="getBadgeStyle(expenseData?.category, true)">
          {{ expenseData?.category?.name || expenseData?.categoryName || '-' }}
        </span>
      </div>
      <h2 class="premium-view-amount mb-1">₹{{ expenseData?.amount | number }}</h2>
      <div class="premium-view-description mb-2">{{ expenseData?.description || '-' }}</div>
      <div class="premium-view-record">
        Recorded on {{ expenseData?.created | date:'dd MMM yyyy, hh:mm a':'Asia/Kolkata' }}
      </div>
    </div>
    <!-- Details List -->
    <h6 class="premium-details-heading mb-3">Payment Details</h6>
    <div class="d-flex flex-column gap-3">
      <div class="d-flex justify-content-between align-items-center border-bottom pb-2">
        <span class="premium-view-label">Branch</span>
        <span class="premium-view-value">{{ expenseData?.company?.name || '-' }}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center border-bottom pb-2">
        <span class="premium-view-label">Category</span>
        <span class="premium-view-value">{{ expenseData?.category?.name || '-' }}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center border-bottom pb-2">
        <span class="premium-view-label">Payment Mode</span>
        <span class="premium-view-value">{{ expenseData?.paymentMode || '-' }}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center border-bottom pb-2">
        <span class="premium-view-label">Payment Account</span>
        <span class="premium-view-value">{{ expenseData?.paymentAccount?.accountName || '-' }}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center border-bottom pb-2">
        <span class="premium-view-label">Recorded By</span>
        <span class="premium-view-value">{{ expenseData?.createdBy?.name || '-' }}</span>
      </div>
      <div class="d-flex justify-content-between align-items-center border-bottom pb-2">
        <span class="premium-view-label">Date</span>
        <span class="premium-view-value">{{ expenseData?.transactionDate | date:'dd MMM yyyy':'Asia/Kolkata' }}</span>
      </div>
    </div>
  }
  <!-- ADD / EDIT MODE (FORM) -->
  @if (mode === 'ADD' || mode === 'EDIT') {
    <form [formGroup]="expenseForm" class="d-flex flex-column gap-3">
      <!-- Branch -->
      @if (isBranchVisible) {
        <div>
          <label class="form-label premium-form-label mb-1" for="branchSelect">Branch</label>
          <ng-select labelForId="branchSelect" [items]="branches" bindLabel="name" bindValue="_id" formControlName="company" [clearable]="false"
            placeholder="Select Branch" class="custom-ng-select premium-select">
          </ng-select>
        </div>
      }
      <!-- Amount -->
      <div>
        <label class="form-label premium-form-label mb-1" for="amountInput">Amount</label>
        <input type="number" id="amountInput" class="form-control premium-input" formControlName="amount" placeholder="0">
      </div>
      <!-- Category -->
      <div>
        <span class="form-label premium-form-label mb-1 d-block">Category</span>
        <div class="d-flex flex-wrap gap-2 mb-2 align-items-center" style="min-height: 48px;">
          @for (cat of pillCategories; track cat) {
            <button type="button" class="btn rounded-pill pill-btn"
              [ngStyle]="getBadgeStyle(cat, expenseForm.get('category')?.value === cat._id)"
              [disabled]="saveLoader || deleteLoader" (click)="selectCategory(cat._id)">
              {{ cat.name }}
            </button>
          }
        </div>
        <!-- Overflow Category ng-select with beautiful label -->
        <div class="mt-3">
          <label class="form-label premium-form-label mb-1" for="otherCategoriesSelect">Other Categories</label>
          <ng-select labelForId="otherCategoriesSelect" [items]="dropdownCategories" bindLabel="name" bindValue="_id"
            [ngModel]="getDropdownCategoryValue()" (ngModelChange)="onDropdownCategoryChange($event)"
            [ngModelOptions]="{standalone: true}" [clearable]="true" placeholder="Select Other Category"
            (scrollToEnd)="scrollCategories()" [loading]="categoriesObj.loader"
            class="custom-ng-select premium-select">
          </ng-select>
        </div>
      </div>
      <!-- Payment Mode -->
      <div>
        <label class="form-label premium-form-label mb-1" for="paymentModeSelect">Payment Mode</label>
        <ng-select labelForId="paymentModeSelect" [items]="paymentModes" bindLabel="label" bindValue="key" formControlName="paymentMode"
          [clearable]="false" placeholder="Select Mode" class="custom-ng-select premium-select">
        </ng-select>
      </div>
      <!-- Payment Account -->
      <div>
        <label class="form-label premium-form-label mb-1" for="paymentAccountSelect">Payment Account</label>
        <ng-select labelForId="paymentAccountSelect" [items]="paymentAccounts" bindLabel="accountName" bindValue="_id" formControlName="paymentAccount"
          [clearable]="false" placeholder="Select Account" class="custom-ng-select premium-select">
        </ng-select>
      </div>
      <!-- Date Container for anchoring datepicker -->
      <div #dateContainer class="position-relative">
        <span class="form-label premium-form-label mb-1 d-block">Date</span>
        <div
          class="premium-input d-flex align-items-center justify-content-between px-3 py-2 border rounded cursor-pointer bg-white"
          [ngClass]="{'form-disabled': saveLoader || deleteLoader}"
          (click)="!(saveLoader || deleteLoader) && dp.toggle()">
          <span class="fw-medium text-dark">{{ dateValueFormatted }}</span>
          <i class="fa fa-chevron-down text-muted small"></i>
        </div>
        <!-- Hidden input positioned targets dateContainer to prevent top-left rendering bug -->
        <input class="datepicker-hidden-input" name="dp" ngbDatepicker #dp="ngbDatepicker"
          [positionTarget]="dateContainer" [maxDate]="maxDate" [startDate]="selectedNgbDate"
          [(ngModel)]="selectedNgbDate" [ngModelOptions]="{standalone: true}" (dateSelect)="onDateSelect($event)">
        </div>
        <!-- Notes -->
        <div>
          <label class="form-label premium-form-label mb-1" for="notesInput">Notes</label>
          <input type="text" id="notesInput" class="form-control premium-input" formControlName="description"
            placeholder="e.g. Fuel purchase, rent..." maxlength="30">
            @if (expenseForm.get('description')?.value?.length >= 30) {
              <div class="text-danger mt-1"
                style="font-size: 11px; font-weight: 500;">
                Maximum 30 characters reached
              </div>
            }
          </div>
        </form>
      }
    </div>
    <div class="offcanvas-footer border-top p-3 bg-white d-flex flex-column gap-2">
      @if (mode === 'VIEW') {
        <button class="btn premium-btn-dark w-100 py-2" [disabled]="saveLoader || deleteLoader"
        (click)="switchToEdit()">Edit Expense</button>
        <button class="btn btn-outline-danger w-100 py-2 d-flex justify-content-center align-items-center gap-2"
          [disabled]="saveLoader || deleteLoader" (click)="confirmDelete()">
          @if (deleteLoader) {
            <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
          }
          @if (!deleteLoader) {
            <span>Delete Expense</span>
          }
        </button>
      }

      @if (mode === 'ADD' || mode === 'EDIT') {
        <button class="btn premium-btn-dark w-100 py-2 d-flex justify-content-center align-items-center gap-2"
          [disabled]="expenseForm.invalid || saveLoader || deleteLoader" (click)="saveExpense()">
          @if (saveLoader) {
            <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
          }
          @if (!saveLoader) {
            <span>{{ mode === 'ADD' ? 'Add Expense' : 'Save Changes' }}</span>
          }
        </button>
        <button class="btn premium-btn-cancel w-100 py-2" [disabled]="saveLoader || deleteLoader"
        (click)="activeOffcanvas.dismiss()">Cancel</button>
      }
    </div>